import iconsPng from '@/assets/img/png/icons';
import ConfirmationModal from '@/components/molecules/ConfirmationModal';
import { useAuthContext } from '@/context/auth/useAuthContext';
import { Image, VStack } from '@chakra-ui/react';

interface OrganizationRosterDeleteItemModalProps {
  deleteConfirmationModalVisible: boolean;
  setDeleteConfirmationModalVisible: (modalVisible: boolean) => void;
  deleteItem: (itemId: string) => void;
  itemToDeleteId: string;
  itemToDeleteEmail: string;
}

const OrganizationRosterDeleteMemberModal = ({
  deleteConfirmationModalVisible,
  setDeleteConfirmationModalVisible,
  deleteItem,
  itemToDeleteId,
  itemToDeleteEmail,
}: OrganizationRosterDeleteItemModalProps) => {
  const { isSuperAdmin } = useAuthContext();

  return (
    <ConfirmationModal
      isOpen={deleteConfirmationModalVisible}
      onClose={() => setDeleteConfirmationModalVisible(false)}
      confirmButtonColor="extra.red"
      confirmButtonText="Delete"
      onConfirm={() => {
        deleteItem(itemToDeleteId);
        setDeleteConfirmationModalVisible(false);
      }}
      title="Confirm Deletion"
      subTitleImage={
        <VStack
          bg={'white'}
          justifyContent={'center'}
          alignItems={'center'}
          borderRadius={'20px'}
          boxShadow={'0px 6px 34px 0px #00417933'}
          marginY={'10px'}
        >
          <Image src={iconsPng.whiteExclamationOnRedSquare} height={28} width={28} />
        </VStack>
      }
      description={`Are you sure you want to remove ${itemToDeleteEmail}?`}
      isConfirmButtonDisabled={isSuperAdmin} // Disable if user is a super admin
    />
  );
};

export default OrganizationRosterDeleteMemberModal;
